const $win = $(window);
const $doc = $(document);

const $body = $('body');
const $cart = $('.section-cart .form--cart');
const $cartPopup = $('.cart-wrapper');
const $cartPopupForm = $cartPopup.find('form');

const btnQty = '.product__qty .btn-qty';
const cartProductQty = '.cart-wrapper .field--quantity';
const productQty = '.section-cart .field--quantity';
const addToCartForm = 'form[action="/cart/add"]';

let updateContent = true;

$doc
  .on('submit', addToCartForm, function(e) {
    e.preventDefault();

    $body.addClass('loading');
    addToCart($(this));
  })
  .on('change', cartProductQty, function(e) {
    const $form = $(this).closest('form');
    updateCart($form);
  })
  .on('change', productQty, function(e) {
    const $form = $(this).closest('form');
    updateCart($form);
  })
  .on('click', '.link-remove', function(e) {
    e.preventDefault();
    let href = $(this).attr('href');

    // $(this)
    //   .closest('.table')
    //   .slideUp();
    removeProduct(href);
  });

function removeProduct($this) {
  $.post($this).done(function() {
    $.ajax({
      url: '/cart',
      success: function(response) {
        updateCount(response);
        updateCartContent(response, true);
      },
    });
  });
}

function clickOutside($container, e) {
  let toggleClass = $container.data('toggle-class');

  // console.log(toggleClass);
  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    $('.wrapper').removeClass(toggleClass);
  }
}

// Add product to cart with Ajax //
function addToCart($form) {
  var serializeForm = $form.serialize();

  $.ajax({
    type: 'POST',
    url: '/cart/add',
    dataType: 'html',
    data: serializeForm,
    success: function(response) {
      $body.addClass('cart-expanded').removeClass('loading');

      updateCartContent(response, true);
      updateCount(response);
    },
    error: function(data) {
      console.log(data);
    },
  });
}

function updateCart($form) {
  const serializeForm = $form.serialize();

  $.ajax({
    url: '/cart/update',
    dataType: 'html',
    data: serializeForm,
    success: function(response) {
      updateCount(response);
      updateCartContent(response, false);
    },
    error: function(data) {
      console.log(data);
    },
  });
}

function updateCartContent(response, updateContent) {
  const $form = $(response).find('.section-cart form');
  const $formBody = $form.find('.form__body');
  const $count = $(response).find('.header .count');
  // const $formAside = $form.find('.form__aside');
  const $cart = $('.section-cart .form--cart');

  if ($cart.length == 0) {
    if (updateContent) {
      $cartPopupForm.html($form.html());
    } else {
      $cartPopupForm.find('.form__body').html($formBody.html());
    }
  } else {
    if (updateContent) {
      $cart.html($form.html());
    } else {
      $cart.find('.form__body').html($formBody.html());
    }
  }
}

function updateCount(response) {
  const $cartTrigger = $(response).find('.header .cart-trigger');
  $('.cart-trigger').each(function() {
    $(this).html($cartTrigger.html());
  });
}
